import { Vue, Options } from 'vue-class-component';
import i18n from '@/core/translations/i18n';

export enum HelpType {
  CallModeTypes,
  RiserInterface
}

@Options({
  name: 'HelpPopupButton',
  props: {
    helpType: {
      type: Number as () => HelpType,
      required: true,
    },
  }
})
export default class HelpPopupButton extends Vue {
  helpType!: HelpType;
  showHelpDialog = false;
  HelpTypeEnum = HelpType;
  title = i18n.global.t('AppResource.Help');

  get description() {
    switch (this.helpType) {
      case HelpType.CallModeTypes:
        return i18n.global.t('AppResourceEP.DisplayOfCallModeTypes');
      case HelpType.RiserInterface:
        return i18n.global.t('AppResourceEP.HowManyRisersQuestion');
      default:
        return '';
    }
  }

  toggleHelpDialog() {
    this.showHelpDialog = !this.showHelpDialog;
  }

  get callModeHelpDescription() {
    return this.$t('AppResourceEP.CallModeHelpDescription').split('\n');
  }

  get riserInterfaceHelpDescription() {
    return this.$t('AppResourceEP.RiserInterfacesHelpPageDescription').split('\n');
  }

  get riserInterfaceHelpPoints() {
    return this.$t('AppResourceEP.RiserInterfacesHelpPageExample').split('\n');
  }

  handleDropdownVisibleChange(visible: boolean) {
    this.showHelpDialog = visible;
  }
}
